import { AppState } from '@/app/app-reducer';
import {
  ALWAYS_ENABLED_PROPERTY_DETAILS_TABS,
  DEFAULT_PROPERTY_DETAILS_TAB,
  PROPERTY_DETAILS_TAB_NAMES,
} from '@/constants';
import {
  enabledBetaFeatures,
  propertyDetailsTabs,
  strComplaintsAvailable,
} from '@/data/data-selectors';
import { createSelector } from 'reselect';
import { IDashboardReduxState } from './dashboard-types';

const dashboardState = (state: AppState) => state.dashboard;

export const selectedSidebarItems = (state: AppState) =>
  state.dashboard.selectedSidebarItems;

export const dashboardReady = (state: AppState) =>
  state.dashboard.dashboardReady;

export const isUniversalSearchActive = (state: AppState) =>
  state.dashboard.isUniversalSearchActive;

export const maybeActivePropertyDetailsTab = (state: AppState) =>
  state.dashboard.activePropertyDetailsTab;

export const activePropertyDetailsTab = createSelector(
  // @ts-expect-error Untyped state
  propertyDetailsTabs,
  maybeActivePropertyDetailsTab,
  strComplaintsAvailable,
  enabledBetaFeatures,
  (pdTabs, activeTab, complaintsTabEnabled, enabledBetaFeatures) => {
    // @ts-expect-error Untyped state
    if (ALWAYS_ENABLED_PROPERTY_DETAILS_TABS.has(activeTab)) return activeTab;

    // @ts-expect-error Untyped state
    const isTabEnabledInStatsJSON = pdTabs?.[activeTab]?.enabled;
    if (isTabEnabledInStatsJSON) return activeTab;

    if (
      activeTab === PROPERTY_DETAILS_TAB_NAMES.complaints &&
      complaintsTabEnabled
    ) {
      return activeTab;
    }

    // @ts-expect-error Untyped state
    const isTabEnabledViaBetaFeature = enabledBetaFeatures.includes(activeTab);
    if (isTabEnabledViaBetaFeature) return activeTab;

    return DEFAULT_PROPERTY_DETAILS_TAB;
  }
);

export const loadingText = (state: AppState) => state.dashboard.loadingText;

export const permitContext: (
  state: AppState
) => IDashboardReduxState['permitContext'] = createSelector(
  dashboardState,
  (dashState) => dashState.get('permitContext')
);
